import { axiosInstance } from '../../config/axiosConfig';
import { AxiosError, AxiosResponse } from 'axios';
import { IClientInsurerReqBody, IClientInsurersResponse } from '../types/insurerjurisdiction.type';
import { endPointUrls } from '../constants/endPoints';

const getClientInsurers = (locations: IClientInsurerReqBody[]): Promise<IClientInsurersResponse> => {
    return axiosInstance
        .post(endPointUrls.getClientInsurers, { locations })
        .then((res: AxiosResponse<IClientInsurersResponse>) => {
            return res.data;
        })
        .catch((error: AxiosError) => {
            throw error;
        });
};

const insurerJurisdictionServices = {
    getClientInsurers,
};

export default insurerJurisdictionServices;
